@for (icon of icons(); track icon; let i = $index) {
    <span [attr.role]="hasButton() ? 'button' : 'img'" (click)="onClick($event)">
        <!-- Icona AngularMaterial (default) -->
        @if (!icon?.iconType || icon?.iconType === 0) {
            <mat-icon
                class="multi-icon-cell-renderer"
                [class.multi-icon-cell-renderer-hidden]="icon.hidden"
                [title]="icon.title"
            >
                {{ icon?.icon }}
            </mat-icon>
        }

        <!-- Icona SeSvg -->
        @if (icon?.iconType === 1) {
            <mat-icon
                class="multi-icon-cell-renderer svg-icon"
                [svgIcon]="icon?.icon"
                [class.multi-icon-cell-renderer-hidden]="icon.hidden"
                [title]="icon.title"
            ></mat-icon>
        }

        <!-- Icona SeFont -->
        @if (icon?.iconType === 2) {
            <mat-icon
                fontSet="estensa-icons"
                class="multi-icon-cell-renderer"
                [class.multi-icon-cell-renderer-hidden]="icon.hidden"
                [style]="{ 'font-size': icon?.iconSize }"
                [title]="icon.title"
            >
                {{ icon?.icon }}
            </mat-icon>
        }
    </span>
}
